export const trim = function (value: string | object): string | object {
  if (typeof value === "string") {
    return String(value).trim();
  }
  if (Array.isArray(value)) {
    return value.map(trim);
  }
  if (typeof value === "object") {
    const data = {};
    for (const name of Object.keys(value)) {
      // @ts-ignore
      data[name] = trim(value[name]);
    }
    return data;
  }
  return value;
}